function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.8061 9.51484L16.875 10.4804L14.375 5.69271L16.3257 4.71735C16.4723 4.64407 16.6418 4.63128 16.7977 4.68173C16.9536 4.73217 17.0834 4.84183 17.1593 4.98707L19.0806 8.66653C19.119 8.7401 19.1424 8.82059 19.1493 8.9033C19.1563 8.98601 19.1468 9.06927 19.1212 9.14824C19.0956 9.22721 19.0546 9.3003 19.0005 9.36324C18.9464 9.42618 18.8803 9.47772 18.8061 9.51484Z",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.12519 10.3961L1.19412 9.43061C1.11989 9.39349 1.05378 9.34196 0.999679 9.27902C0.945572 9.21608 0.904545 9.14299 0.878991 9.06402C0.853437 8.98505 0.843869 8.90178 0.850844 8.81907C0.857819 8.73637 0.881198 8.65588 0.919617 8.5823L2.84094 4.90285C2.91678 4.7576 3.04663 4.64795 3.20253 4.5975C3.35843 4.54705 3.52791 4.55984 3.67446 4.63312L5.62519 5.60848L3.12519 10.3961Z",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 10.48L15.625 11.9423L12.7502 14.8171C12.6739 14.8934 12.5791 14.9487 12.4751 14.9775C12.3711 15.0063 12.2614 15.0077 12.1567 14.9815L7.62881 13.8495C7.54389 13.8283 7.46437 13.7895 7.3954 13.7355L3.125 10.3962",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6252 11.9424L12.1877 9.44238L11.1877 10.1924C10.7549 10.5169 10.2286 10.6924 9.68766 10.6924C9.14673 10.6924 8.6204 10.5169 8.18766 10.1924L7.76416 9.87476C7.69252 9.82104 7.63327 9.75254 7.59041 9.67392C7.54755 9.5953 7.52208 9.50839 7.51573 9.41907C7.50938 9.32975 7.5223 9.24011 7.55362 9.15621C7.58493 9.07232 7.6339 8.99614 7.69722 8.93282L10.7546 5.87544C10.8126 5.8174 10.8815 5.77137 10.9574 5.73996C11.0332 5.70855 11.1145 5.69238 11.1965 5.69238H14.3752",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M5.66992 5.6084L9.6793 4.43953C9.82252 4.39778 9.97596 4.40863 10.1119 4.47013L12.8125 5.69213",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 16.6298L6.39536 16.0411C6.29981 16.0173 6.21125 15.9711 6.13692 15.9065L4.375 14.375",
  stroke: "#263D5C",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgHandshake = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHandshake, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/handshake.f24bca8f.svg";
export { ForwardRef as ReactComponent };